import { Layout, Menu, Icon } from 'antd'
import { Component } from 'react'
import * as React from 'react'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { ThunkDispatch } from "redux-thunk"
import { AnyAction } from "redux"
import { RootState } from '../../core/reducers'
import logo from '../../assets/images/logo.png'
import { actionGetInstitution } from '../../core/actions/institution'
import menuData from '../../assets/javascripts/menu'

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

interface StateProps {
    collapsed: boolean
    institution: any
}

interface DispatchProps {
    getInstitution(): void
}

type PropsType = RouteComponentProps & StateProps

class SiderNav extends Component<PropsType & DispatchProps> {
   
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let institution = this.props.institution;
        if(institution.id) return ;
        this.props.getInstitution();
    }
    
    state = {
        SubMenu: null,
        openKeys: ['']
    }

    refreshKey = () => {
        this.getSubMenu(menuData);
        const { history } = this.props;
        let pathname = history.location.pathname;
        for(let i in menuData) {
            if(pathname.search(menuData[i].path) === 0) {
                return {
                    selectedKeys: [`${menuData[i].key}`],
                    openKeys: [`${menuData[i].key}`]
                }
            }
            else if(pathname.search('/institution') === 0){
                return {
                    selectedKeys: ['institution'],
                    openKeys: ['institution']
                }
            }
        }
        return null;
    }

    getSubMenuChildren = (data) => {
        return (
             <SubMenu
                 title={
                     <span>{data.name}</span>
                 }
                 key={data.key}
                 >
                 {
                     data.children.map((item, index) => {
                         return (
                             <MenuItem key={item.key}>
                                 <Link to={data.path + item.path}>{item.name}</Link>
                             </MenuItem>
                         )
                     })
                 }
             </SubMenu>
         )
             
     }

     getSubMenu = (menuData) => {
        this.state['SubMenu'] = menuData.map((item) => {
            if(item.children) {
                return (
                    <SubMenu
                        title={
                            <span>
                                <Icon type={item.icon} />
                                <span>{item.name}</span>
                            </span>
                        }
                        key={item.key}
                        >
                        {
                            item.children.map((data, index) => {
                                if(data.children) {
                                    let subMenuChildren = this.getSubMenuChildren(data);
                                    return subMenuChildren;
                                }
                                else {
                                    return (
                                        <MenuItem key={data.key}>
                                            <Link to={data.path}>{data.name}</Link>
                                        </MenuItem>
                                    )
                                }
                            })
                        }
                    </SubMenu>
                )
            }
            else {
                return (
                    <MenuItem key={item.key}>
                        <Icon type={item.icon} />
                        <Link to={item.path}>{item.name}</Link>
                    </MenuItem>
                )
            }
        })
    }

    onOpenChange = (openKeys) => {
       this.setState({ openKeys });
    }

    render() {
        let refreshData = this.refreshKey();
        let data = this.props.institution || {}

        return (
            <Sider
                trigger={null}
                collapsible
                width={256}
                collapsed={this.props.collapsed}
                >
                <div className="logo" >
                    {data.logo ? <img src={data.logo} /> : <img src={logo} />}
                    <p>{data.name}</p>
                </div>
                <Menu 
                    theme="dark" 
                    mode="inline" 
                    defaultSelectedKeys={refreshData ? refreshData.selectedKeys: ['reportList']} 
                    defaultOpenKeys={refreshData ? refreshData.openKeys : ['reportManage']}
                    openKeys={this.state['openKeys'] ? this.state['openKeys'] : (refreshData ? refreshData.openKeys : [''])}
                    selectedKeys={refreshData ?  refreshData.selectedKeys : ['reportList']}
                    onOpenChange={this.onOpenChange}
                    >
                    {this.state['SubMenu']}
                </Menu>
            </Sider>
        );
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        collapsed: state.style.collapsed,
        institution: state.institution.institution
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getInstitution: () => {
            dispatch(actionGetInstitution())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiderNav) as any)